<template>
  <div
    v-if="discount"
    class="text-caption text-success"
    data-cy="discount-costs">
    {{ text }}
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();
const props = defineProps<{ discount: any }>();

const text = computed(() => {
  const d = props.discount;
  if (!d) return "";
  const params = {
    code: d.code,
    discounted: d.discountedCosts,
    list: d.listCosts,
    months: d.months,
    date: d.end ? new Date(d.end * 1000).toLocaleDateString() : "",
    interpolation: { escapeValue: false }
  };
  let key: string = d.duration;
  if (key === "repeating") {
    // a new code counts months, an active one ends at a date
    if (d.active) key = d.end ? "repeatingUntil" : "repeatingRemaining";
  } else if (key === "once" && d.active) key = "onceActive";
  return t("views.licence.promo.line." + key, params);
});
</script>
